import { render, staticRenderFns } from "./Blurb.vue?vue&type=template&id=404e1df2&scoped=true"
import script from "./Blurb.vue?vue&type=script&lang=js"
export * from "./Blurb.vue?vue&type=script&lang=js"
import style0 from "./Blurb.vue?vue&type=style&index=0&id=404e1df2&prod&scoped=true&lang=css"
import style1 from "./Blurb.vue?vue&type=style&index=1&id=404e1df2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404e1df2",
  null
  
)

export default component.exports